import { useEffect, useState } from 'react';

const PROVISIONING_GRACE_MS = 15000;

export function useProvisioningGrace(active: boolean): boolean {
  const [graceExpired, setGraceExpired] = useState(false);

  useEffect(() => {
    if (!active) {
      setGraceExpired(false);
      return;
    }
    const timer = setTimeout(() => setGraceExpired(true), PROVISIONING_GRACE_MS);
    return () => clearTimeout(timer);
  }, [active]);

  return graceExpired;
}
